import React, { ReactElement, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Grid } from '@mui/material';
import {
  InvestmgrContextProvider,
  SetUpdateHookContextProvider,
  PathHook
} from '../hooks/datatabs';
import { InvestMgr, Nullable } from '../types/types';
import { investmgrsTabs } from '../utils/tabs';
import InvestMgrHeader from '../containers/investmentmanagers/pageheader';
import DisplayTabs from '../components/layout/tabs/tabs';
import { InvestMgrService } from '../services/investmgr';
import ServiceError from '../services/errors';
import ErrorPageManager from '../components/Error/errorpagemanager';
import TabsRouter from './tabsrouter';

function InvestMgrRouter(): ReactElement {
  const { id } = useParams<{ id: string }>();
  const [update, setUpdate] = useState(true);
  const [data, setData] = useState<Nullable<InvestMgr>>(null);
  const investmgrService = new InvestMgrService();
  const [error, setError] = useState<Nullable<ServiceError>>(null);

  useEffect(() => {
    if (update && id) {
      data && setData(null);

      investmgrService.getEntity(id)
        .then((apiResp) => {
          setData(apiResp.data);
          setUpdate(false);
        })
        .catch((err) => {
          setError(ServiceError.ensureServiceError(err));
          setUpdate(false);
        });
    }
  }, [update, id]);

  PathHook(`${data?.name}`);

  return (
    <SetUpdateHookContextProvider value={setUpdate}>
      <Grid container spacing={2}>
        { error ? <ErrorPageManager error={error} /> :
          <InvestmgrContextProvider value={data}>
            <Grid item xs={12}>
              <InvestMgrHeader entity={data}/>
            </Grid>
            <Grid item xs={12}>
              <DisplayTabs tabs={investmgrsTabs} />
            </Grid>
            <Grid item xs={12}>
              <TabsRouter tabs={investmgrsTabs} />
            </Grid>
          </InvestmgrContextProvider>
        }
      </Grid>
    </SetUpdateHookContextProvider>
  );
}

export default InvestMgrRouter;
